import React, { FC, useState, useEffect } from 'react';
import LocalModal from 'components/base/local-modal';
import { ReactComponent as ListIcon } from 'assets/icons/list-icon.svg';
import { Button } from '@cokitchen/cokitchen-components';
import CsvIcon from 'assets/images/csv.png';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
// import { DefaultvendorFormData } from '../add-vendor';
import CsvInfoModal from '../csv-info-modal';
import useInventoryStoreContext from 'contexts/inventory-store.context/context';
import * as XLSX from 'xlsx';
import {
  XlsStoreItem,
  FormattedStoreItem,
  FormattedVendorItem,
  XlsVendorItem
} from 'models/store-item.model';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_UNIT } from 'models/common.model';

type AddStoreItemProps = {
  show: boolean;
  onClose: () => void;
};

const StoreItemAdditionDetails = {
  subtitle:
    'Welcome to the store item addition process via CSV file. Please Follow these steps to ensure a smooth member addition:',
  steps: [
    {
      number: 1,
      heading: 'Download the Template',
      description: "Click the 'Download CSV Template' button to obtain the template file."
    },
    {
      number: 2,
      heading: 'Fill in store items Details',
      description: ' Open the downloaded CSV file, Specify the role of each vendor.'
    },
    {
      number: 3,
      heading: 'Save Your Changes',
      description: 'Save the CSV file with your entries'
    },
    {
      number: 4,
      heading: 'Review',
      description:
        'Crosscheck the details in the CSV file. Click confirm to select the file and upload'
    },
    {
      number: 5,
      heading: 'Verify the details',
      description:
        'After uploading, the details will be displayed for final review before addition,then click continue to add members to the company'
    }
  ]
};
const AddStoreItemModal: FC<AddStoreItemProps> = ({ show, onClose }) => {
  const navigate = useNavigate();
  const { formVendorsList } = useDashboardContext();
  const [showCsvInfoModal, setShowCsvInfoModal] = useState(false);
  const { active, setActive, setStep, setStoreItemArray } = useInventoryStoreContext();
  const [file, setFile] = useState<File | null>(null);
  const toggleCsvInfoModal = () => {
    setShowCsvInfoModal(!showCsvInfoModal);
  };

  const readFile = () => {
    if (file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = (event) => {
        const arrayBuffer = event.target?.result;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });

        const storeItemSheet = workbook.Sheets[workbook.SheetNames[0]];
        const vendorSheet = workbook.Sheets[workbook.SheetNames[1]];

        const storeItemData: FormattedStoreItem[] = XLSX.utils
          .sheet_to_json<XlsStoreItem>(storeItemSheet)
          .map((row) => ({
            item: row['Item Name'],
            category: row['Category'],
            min_qty: row['Min. Qty'],
            'unit/g': row['Unit per (weight)'],
            weight: row['Weight'],
            vendors: []
          }));

        const vendorData: FormattedVendorItem[] = XLSX.utils
          .sheet_to_json<XlsVendorItem>(vendorSheet)
          .map((row) => ({
            vendor_name: row['Vendor'],
            store_item: row['Store Item'],
            price: row['Price'] ?? 0
          }));

        storeItemData.forEach((storeItem) => {
          const matchingVendors = vendorData.filter(
            (vendor) => vendor?.store_item?.toLowerCase() === storeItem?.item?.toLowerCase()
          );
          storeItem.vendors = matchingVendors;
        });

        storeItemData.forEach((storeItem) => {
          storeItem.vendors = storeItem.vendors.filter((vendor) => {
            const matchedVendor = formVendorsList.find(
              (formVendor) => formVendor?.name?.toLowerCase() === vendor?.vendor_name?.toLowerCase()
            );

            if (matchedVendor) {
              vendor.id = matchedVendor.id;
              return true;
            }
            return false;
          });
        });
        setStoreItemArray(
          storeItemData.map((store_item) => ({
            name: store_item.item,
            quantity: store_item.min_qty,
            unit: store_item['unit/g'],
            category: store_item.category,
            min_quantity_unit: store_item.weight as ENUM_UNIT,
            vendors: store_item.vendors.map((vendor) => ({
              name: vendor.vendor_name,
              price: vendor.price,
              id: vendor.id || ''
            })),
            shelfLife: store_item?.shelfLife || 0
          }))
        );

        navigate(MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_ADD);
        setStep(2);
        setActive('csv');
      };
    }
  };

  useEffect(() => {
    readFile();
  }, [file]);

  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    setActive('csv');
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files) setFile(files[0]);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };
  const handleFileUpload = (e: any) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };
  const reset = () => {
    setActive('csv');
    // setVendorFormData([]);
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={() => {
        onClose();
        setActive(null);
      }}
      title='Add new item'
      contentClassName='!max-w-[442px]'>
      <div className='flex gap-4 my-4 w-full '>
        <div
          onClick={() => {
            setActive('csv');
            toggleCsvInfoModal();
          }}
          onDrop={handleFileDrop}
          onDragOver={handleDragOver}
          className={`${
            active === 'csv' ? 'border-[#E60A2B] border-[1.5px]' : 'border-[#EAEBEB]'
          } border w-full sm:w-[185px] h-[139px]  hover:border-[#E60A2B] cursor-pointer hover:border-[1.5px] p-4 rounded-md space-y-3`}>
          <div className='border border-[#EAEBEB] p-2 rounded-full w-9 h-9 flex items-center'>
            <img src={CsvIcon} alt='' />
          </div>
          <h2 className='text-sm font-semibold'>Add via .csv</h2>
          <p className='text-[#6F7376] text-xs font-normal'>
            Add multiple meals to the conversion list
          </p>
        </div>

        <div
          onClick={() => {
            setActive('manual');
            // setVendorFormData([DefaultvendorFormData]);
          }}
          className={`${
            active === 'manual' ? 'border-[#E60A2B] border-[1.5px]' : 'border-[#EAEBEB] '
          } border w-full sm:w-[185px] h-[139px] hover:border-[#E60A2B] cursor-pointer hover:border-[1.5px] p-4 rounded-md space-y-3`}>
          <div className='border border-[#EAEBEB] p-2 rounded-full w-9 h-9 flex items-center'>
            <ListIcon />
          </div>
          <h2 className='text-sm font-semibold'>Add Manually</h2>
          <p className='text-[#6F7376] text-xs font-normal '>
            Add meals manually to the conversion list
          </p>
        </div>
      </div>
      <div className='flex justify-end mt-6 '>
        <Button
          color='transparent'
          variant='block'
          small
          className='w-[139px] '
          onClick={() => {
            onClose();
            setActive(null);
          }}>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='block'
          small
          className='w-[139px]'
          onClick={() =>
            active === 'csv'
              ? toggleCsvInfoModal()
              : navigate(MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS_ADD)
          }>
          Continue
        </Button>
      </div>
      {showCsvInfoModal && (
        <CsvInfoModal
          show={showCsvInfoModal}
          onClose={toggleCsvInfoModal}
          handleFileUpload={handleFileUpload}
          handleFileChange={reset}
          title='Add store items via CSV file'
          downloadLink='https://docs.google.com/spreadsheets/d/1n2pCQJKaZGrDUJp0a7ErMXS7lbYajlBZT5ErJ8-pOkc/edit?usp=sharing'>
          <div className='w-full max-w-[400px]'>
            <h2 className='text-sm text-[#2E3031]'>{StoreItemAdditionDetails.subtitle}</h2>
            <div>
              {StoreItemAdditionDetails.steps.map((step) => (
                <div className='flex items-center max-w-[400px]' key={step.number}>
                  <div className='inline-block relative'>
                    <span className='w-5 h-5 bg-[#e7e8e9] text-sm rounded-full flex items-center justify-center mb-2 mr-2 p-1'>
                      {step.number}
                    </span>
                  </div>
                  <span className='mt-3'>
                    <h3 className='text-sm font-medium '>{step.heading}</h3>
                    <p className='text-xs'>{step.description}</p>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </CsvInfoModal>
      )}
    </LocalModal>
  );
};

export default AddStoreItemModal;
